<template>
  <v-col cols="12">
    <div>
      <naj-box
        :no-header="hideNajBox"
        :no-gutters="hideNajBox"
        :no-margin-bottom="hideNajBox"
        :title="locales.sectionTitle"
      >
        <v-row>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.deedId"
              :value.sync="formModel.deedId"
              :disabled="isChecking || viewMode"
              validates="required|numeric"
              @input="deedIdChanged"
            ></naj-input>
          </v-col>

          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.date"
              :label="locales.deedDate"
              :value.sync="formModel.deedDate"
              :disabled="isChecking || !formModel.deedId || viewMode"
              validates="required"
              @change="deedDateChanged"
            ></naj-input>
          </v-col>

          <v-col
            cols="4"
            align-self="center"
            class="text-right"
          >
            <naj-button
              v-if="isCheckButtonVisible"
              square
              :loading="isChecking"
              :disabled="isCheckButtonDisabled"
              @click="check"
            >
              {{ local.personInformation.check }}
            </naj-button>
          </v-col>
        </v-row>
      </naj-box>
    </div>

    <div>
      <naj-dynamic-form
        :form-model="formModel"
        :form-fields="form.fields"
        :view-mode="viewMode"
      ></naj-dynamic-form>
    </div>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'RightOfFirstPreemptionDeedInfo',
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: true,
    },
    hideNajBox: {
      type: Boolean,
      required: false,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isRetrieved: false,
      isChecking: false,
      isManual: false,
      form: {
        'id': 123,
        'name': 'RightOfFirstPreemptionForm',
        'label': 'نموذج حق الشفعة',
        'description': 'نموذج حق الشفعة',
        'isCustom': false,
        'customComponentName': null,
        'fields': [
          {
            'typeId': 1,
            'name': 'source',
            'label': 'مصدر الصك',
            'columnSize': 3,
            'sortIndex': 2,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{},"if":""}',
            'description': 'مصدر',
            'fields': [],
          },
          {
            'typeId': 2,
            'name': 'instrumentNumber',
            'label': 'رقم الصك',
            'columnSize': 3,
            'sortIndex': 3,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{},"if":""}',
            'description': 'رقم الصك',
            'fields': [],
          },
          {
            'typeId': 3,
            'name': 'instrumentDate',
            'label': 'تاريخ الصك',
            'columnSize': 3,
            'sortIndex': 4,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{},"if":""}',
            'description': 'تاريخ الصك',
            'fields': [],
          },
        ],
      },
    };
  },
  computed: {
    locales() {
      return this.local.dynamicFormAdmin.customComponents.BuildingInfo;
    },
    isCheckButtonDisabled() {
      return (
        !this.formModel.deedId ||
        !this.formModel.deedDate ||
        this.isChecking
      );
    },
    isCheckButtonVisible() {
      return !this.isRetrieved || this.isChecking;
    },
    isFieldDisabled() {
      return this.isManual || this.isChecking;
    },
  },
  mounted() {
    if (this.formModel.objectKey) {
      this.isRetrieved = true;
    }
  },
  methods: {
    ...mapGlobalActions(['getRealEstateDeedInfo']),
    check() {
      this.isChecking = true;
      this.resetFlags();

      this.getRealEstateDeedInfo({
        deedId: this.formModel.deedId,
        deedDate: this.formModel.deedDate,
      })
        .then((res) => {
          if (res.data) {
            this.isRetrieved = true;
            const deedInfoResult = res.data.deedInfo;

            const mappedData = {
              objectKey: deedInfoResult.deedNumber,
              instrumentNumber: deedInfoResult.deedNumber,
              instrumentDate: this.formModel.deedDate,
              source: deedInfoResult.deedCourtName,
            };
            Object.keys(mappedData)
              .map((key) => {
                this.$set(this.formModel, key, mappedData[key]);
                return key;
              });
          }
        })
        .catch(() => {
          this.isManual = true;
          this.toaster.error(this.local.common.noData);
          this.clearFormData();
        })
        .finally(() => {
          this.isChecking = false;
        });
    },
    resetFlags() {
      this.isRetrieved = false;
      this.isManual = false;
    },
    deedDateChanged() {
      this.resetFlags();
    },
    deedIdChanged() {
      this.resetFlags();
      this.formModel.deedDate = null;
      this.clearFormData();
    },
    getPieceNumber(deedInfo) {
      if (!deedInfo.planNumber) {
        return null;
      }
      return deedInfo.planNumber.split('/')[0];
    },
    getBlockNumber(deedInfo) {
      if (!deedInfo.planNumber) {
        return null;
      }
      return deedInfo.planNumber.split('/')[1];
    },
    getOwnerName(apiData) {
      if (apiData.ownersInformation && apiData.ownersInformation.length > 0) {
        return apiData.ownersInformation[0].ownerName;
      }
      return null;
    },
    clearFormData() {
      const mappedData = {
        objectKey: null,
        instrumentNumber: null,
        instrumentDate: null,
        source: null,
      };
      Object.keys(mappedData)
        .map((key) => {
          this.$set(this.formModel, key, mappedData[key]);
          return key;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>